import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";
import { useDnDBypassContext } from "@/components/builder/utils/bypass-context";

import { MidpathTCPAAnswerCheckboxBlock } from "../..";
import BasePreview from "../../base";

function MidpathTCPAAnswerButtonPreview(props) {
  const { data: { value: data } } = useDnDBypassContext()

  if (!data) return null

  const { answer, isMultipleAnswers } = data

  return <>
    <BasePreview {...props}>
      <button className="tcpa-answer" type="button">
        {isMultipleAnswers ? <Element is={MidpathTCPAAnswerCheckboxBlock} id="checkbox" /> : null} {answer}
      </button>
    </BasePreview>
  </>
}

export default define('tcpa-answer-button', MidpathTCPAAnswerButtonPreview, Fragment)
  .shared(prop.share('MidpathTCPAAnswerButton', 'tcpa-answer').props({ overrideType: 'tcpa-answer-button' }), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    size: { width: "w-full" },
    textAlign: { horizontal: "center" },
    background: { color: 'gray-600' },
    textColor: 'gray-100',
    space: {
      padding: "pt-1 pb-1",
    },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    cursor: 'cursor-pointer',
  })
  .build()
